// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.internalRoot_root__J1tX4 {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background: var(--bg-base);
  color: var(--text-primary);
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, "Apple Color Emoji", "Segoe UI Emoji";
}

.internalRoot_body__0-N9O {
  flex: 1 1;
  min-height: 0;
}

.internalRoot_topbar__mo-wm {
  position: sticky;
  top: 0;
  z-index: 20;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  background: var(--bg-topbar);
  border-bottom: 1px solid var(--border-default);
  backdrop-filter: blur(10px);
}

.internalRoot_topbarLeft__Afhaw {
  display: flex;
  align-items: center;
  gap: 20px;
}

.internalRoot_topbarTitle__s1vzY {
  color: var(--text-primary);
  text-decoration: none;
  font-weight: 600;
  font-size: 14px;
}
.internalRoot_topbarTitle__s1vzY img {
  height: 24px;
}

.internal-root[data-theme="light"] .internalRoot_topbarTitle__s1vzY img {
  filter: invert(1);
}

.internalRoot_topbarRight__j3-NS #internalRoot_shareButton__SBzBZ {
  color: var(--primary);
  margin-right: 2em;
}

.internalRoot_topbarRight__j3-NS {
  display: flex;
  gap: 12px;
  align-items: center;
  color: var(--text-muted);
}

.internalRoot_page__n4xjH {
  min-height: 100vh;
  background: var(--bg-base);
}

.internalRoot_header__Xa-Eb {
  padding: 24px 24px 0;
}

.internalRoot_brand__\\+DV2Y {
  font-weight: 700;
  letter-spacing: 0.2px;
}

.internalRoot_content__LNJPY {
  padding: 24px;
  max-width: 1000px;
  margin: 0 auto;
}

.internalRoot_h1__K1NVo {
  font-size: 20px;
  margin: 0 0 12px;
}

.internalRoot_appList__39EKc {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.internalRoot_appLink__y8NAp {
  background: var(--bg-surface);
  border: 1px solid var(--border-color);
  border-top-color: var(--highlight-color);
  border-radius: 12px;
  padding: 20px 14px;
  color: var(--text-primary);
  text-decoration: none;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.internalRoot_appLink__y8NAp::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 200%;
  height: 200%;
  background: linear-gradient(135deg, transparent 0%, transparent 35%, rgba(255, 255, 255, 0.03) 38%, rgba(255, 255, 255, 0.06) 41%, rgba(255, 255, 255, 0.15) 44%, rgba(255, 255, 255, 0.25) 45.5%, rgba(255, 255, 255, 0.15) 47%, rgba(255, 255, 255, 0.06) 50%, rgba(255, 255, 255, 0.03) 53%, transparent 56%, transparent 100%);
  transform: translate(-100%, -100%);
  transition: none;
  pointer-events: none;
}
.internalRoot_appLink__y8NAp:hover::before {
  transform: translate(10%, 10%);
  transition: transform 1.2s ease-in-out;
}

.internal-root[data-theme="light"] .internalRoot_appLink__y8NAp::before {
  background: linear-gradient(135deg, transparent 0%, transparent 35%, rgba(0, 0, 0, 0.01) 38%, rgba(0, 0, 0, 0.02) 41%, rgba(0, 0, 0, 0.06) 44%, rgba(0, 0, 0, 0.1) 45.5%, rgba(0, 0, 0, 0.06) 47%, rgba(0, 0, 0, 0.02) 50%, rgba(0, 0, 0, 0.01) 53%, transparent 56%, transparent 100%);
}

.internalRoot_appLink__y8NAp:hover {
  filter: brightness(1.05);
}

.internal-root[data-theme="light"] .internalRoot_appLink__y8NAp:hover {
  filter: brightness(0.98);
}

.internalRoot_appName__iHkwo {
  font-weight: 500;
}

.internalRoot_stateBadges__WXe3l {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.internalRoot_stateBadge__z\\+q-l {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--text-muted);
  --badge-icon-filter: brightness(1.25) saturate(1.6) contrast(1.15);
}

.internalRoot_stateBadge__z\\+q-l[data-state-key="in progress"] {
  --badge-icon-filter: brightness(0) saturate(100%) invert(99%) sepia(65%)
    saturate(5941%) hue-rotate(323deg) brightness(115%) contrast(95%);
}

.internalRoot_stateBadge__z\\+q-l[data-state-key="in review"] {
  --badge-icon-filter: brightness(0) saturate(100%) invert(51%) sepia(67%)
    saturate(381%) hue-rotate(70deg) brightness(120%) contrast(95%);
}

.internalRoot_stateBadge__z\\+q-l[data-state-key=done] {
  --badge-icon-filter: brightness(0) saturate(100%) invert(44%) sepia(78%)
    saturate(482%) hue-rotate(197deg) brightness(115%) contrast(95%);
}

.internalRoot_stateBadge__z\\+q-l[data-state-key=canceled],
.internalRoot_stateBadge__z\\+q-l[data-state-key=cancelled],
.internalRoot_stateBadge__z\\+q-l[data-state-key=duplicate] {
  --badge-icon-filter: brightness(0) saturate(100%) invert(74%) sepia(7%)
    saturate(619%) hue-rotate(175deg) brightness(115%) contrast(95%);
}

.internalRoot_stateBadge__z\\+q-l[data-state-key=triage] {
  --badge-icon-filter: brightness(0) saturate(100%) invert(56%) sepia(55%)
    saturate(1002%) hue-rotate(331deg) brightness(120%) contrast(95%);
}

.internalRoot_stateBadge__z\\+q-l[data-state-key=todo],
.internalRoot_stateBadge__z\\+q-l[data-state-key="to do"],
.internalRoot_stateBadge__z\\+q-l[data-state-key=backlog],
.internalRoot_stateBadge__z\\+q-l[data-state-key="extended features"] {
  --badge-icon-filter: brightness(0) saturate(100%) invert(89%) sepia(1%)
    saturate(209%) hue-rotate(72deg) brightness(125%) contrast(100%);
}

.internalRoot_stateBadgeIcon__Scfgh {
  width: 14px;
  height: 14px;
  opacity: 0.9;
  filter: var(--badge-icon-filter, none);
}

.internal-root[data-theme="light"] .internalRoot_stateBadge__z\\+q-l {
  --badge-icon-filter: brightness(0.8) saturate(1.4) contrast(1.1);
}
.internal-root[data-theme="light"] .internalRoot_stateBadge__z\\+q-l[data-state-key="in progress"] {
  --badge-icon-filter: brightness(0) saturate(100%) invert(65%) sepia(65%)
    saturate(5941%) hue-rotate(323deg) brightness(85%) contrast(95%);
}
.internal-root[data-theme="light"] .internalRoot_stateBadge__z\\+q-l[data-state-key="in review"] {
  --badge-icon-filter: brightness(0) saturate(100%) invert(42%) sepia(67%)
    saturate(500%) hue-rotate(70deg) brightness(105%) contrast(90%);
}
.internal-root[data-theme="light"] .internalRoot_stateBadge__z\\+q-l[data-state-key=done] {
  --badge-icon-filter: brightness(0) saturate(100%) invert(25%) sepia(80%)
    saturate(1500%) hue-rotate(197deg) brightness(85%) contrast(100%);
}
.internal-root[data-theme="light"] .internalRoot_stateBadge__z\\+q-l[data-state-key=canceled],
.internal-root[data-theme="light"] .internalRoot_stateBadge__z\\+q-l[data-state-key=cancelled],
.internal-root[data-theme="light"] .internalRoot_stateBadge__z\\+q-l[data-state-key=duplicate] {
  --badge-icon-filter: brightness(0) saturate(100%) invert(40%) sepia(7%)
    saturate(619%) hue-rotate(175deg) brightness(90%) contrast(95%);
}
.internal-root[data-theme="light"] .internalRoot_stateBadge__z\\+q-l[data-state-key=triage] {
  --badge-icon-filter: brightness(0) saturate(100%) invert(25%) sepia(55%)
    saturate(1002%) hue-rotate(331deg) brightness(90%) contrast(95%);
}
.internal-root[data-theme="light"] .internalRoot_stateBadge__z\\+q-l[data-state-key=todo],
.internal-root[data-theme="light"] .internalRoot_stateBadge__z\\+q-l[data-state-key="to do"],
.internal-root[data-theme="light"] .internalRoot_stateBadge__z\\+q-l[data-state-key=backlog],
.internal-root[data-theme="light"] .internalRoot_stateBadge__z\\+q-l[data-state-key="extended features"] {
  --badge-icon-filter: brightness(0) saturate(100%) invert(30%) sepia(1%)
    saturate(209%) hue-rotate(72deg) brightness(70%) contrast(100%);
}

.internalRoot_themeToggle__2ksE\\+ {
  background: var(--fill-default);
  border: 1px solid var(--border-subtle);
  border-radius: 8px;
  padding: 6px;
  cursor: pointer;
  color: var(--text-muted);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s ease, background 0.15s ease;
}
.internalRoot_themeToggle__2ksE\\+:hover {
  color: var(--text-primary);
  background: var(--fill-hover);
}

.internalRoot_button__LUebR {
  background: transparent;
  border: 0;
  color: var(--text-muted);
  padding: 0;
  font-size: 13px;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  line-height: 1;
  font-family: inherit;
}

.internalRoot_button__LUebR:hover {
  color: var(--text-primary);
  text-decoration: underline;
  text-underline-offset: 3px;
}

.internalRoot_button__LUebR:focus-visible {
  outline: 2px solid var(--highlight-color);
  outline-offset: 2px;
}

.internalRoot_muted__\\+goQQ {
  color: var(--text-muted);
  font-size: 13px;
}

.internalRoot_error__XneeB {
  color: var(--color-error);
  font-size: 13px;
  margin-bottom: 12px;
}`, "",{"version":3,"sources":["webpack://./src/internal/styles/internalRoot.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,0BAAA;EACA,+HAAA;AACF;;AAGA;EACE,SAAA;EACA,aAAA;AAAF;;AAGA;EACE,gBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,eAAA;EACA,4BAAA;EACA,8CAAA;EACA,2BAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAAF;;AAGA;EACE,0BAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AAAF;AAEE;EACE,YAAA;AAAJ;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,qBAAA;EACA,iBAAA;AADF;;AAIA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,wBAAA;AADF;;AAIA;EACE,iBAAA;EACA,0BAAA;AADF;;AAIA;EACE,oBAAA;AADF;;AAIA;EACE,gBAAA;EACA,qBAAA;AADF;;AAIA;EACE,aAAA;EACA,iBAAA;EACA,cAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,6BAAA;EACA,qCAAA;EACA,wCAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AADF;AAGE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kUAAA;EAcA,kCAAA;EACA,gBAAA;EACA,oBAAA;AAdJ;AAiBE;EACE,8BAAA;EACA,sCAAA;AAfJ;;AAmBA;EACE,uRAAA;AAhBF;;AAgCA;EACE,wBAAA;AA7BF;;AAgCA;EACE,wBAAA;AA7BF;;AAgCA;EACE,gBAAA;AA7BF;;AAgCA;EACE,aAAA;EACA,QAAA;EACA,eAAA;AA7BF;;AAgCA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,wBAAA;EACA,kEAAA;AA7BF;;AAgCA;EACE;qEAAA;AA5BF;;AA+BA;EACE;mEAAA;AA3BF;;AA8BA;EACE;oEAAA;AA1BF;;AA6BA;;;EAGE;oEAAA;AAzBF;;AA4BA;EACE;qEAAA;AAxBF;;AA2BA;;;;EAIE;oEAAA;AAvBF;;AA2BA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,sCAAA;AAxBF;;AA4BE;EACE,gEAAA;AAzBJ;AA2BE;EACE;oEAAA;AAxBJ;AA2BE;EACE;mEAAA;AAxBJ;AA2BE;EACE;qEAAA;AAxBJ;AA2BE;;;EAGE;mEAAA;AAxBJ;AA2BE;EACE;oEAAA;AAxBJ;AA2BE;;;;EAIE;mEAAA;AAxBJ;;AA6BA;EACE,+BAAA;EACA,sCAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mDAAA;AA1BF;AA4BE;EACE,0BAAA;EACA,6BAAA;AA1BJ;;AA8BA;EACE,uBAAA;EACA,SAAA;EACA,wBAAA;EACA,UAAA;EACA,eAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;EACA,oBAAA;AA3BF;;AA8BA;EACE,0BAAA;EACA,0BAAA;EACA,0BAAA;AA3BF;;AA8BA;EACE,yCAAA;EACA,mBAAA;AA3BF;;AA8BA;EACE,wBAAA;EACA,eAAA;AA3BF;;AA8BA;EACE,yBAAA;EACA,eAAA;EACA,mBAAA;AA3BF","sourcesContent":[".root {\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background: var(--bg-base);\n  color: var(--text-primary);\n  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, \"Apple Color Emoji\",\n    \"Segoe UI Emoji\";\n}\n\n.body {\n  flex: 1;\n  min-height: 0;\n}\n\n.topbar {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  height: 52px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 16px;\n  background: var(--bg-topbar);\n  border-bottom: 1px solid var(--border-default);\n  backdrop-filter: blur(10px);\n}\n\n.topbarLeft {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n}\n\n.topbarTitle {\n  color: var(--text-primary);\n  text-decoration: none;\n  font-weight: 600;\n  font-size: 14px;\n\n  img {\n    height: 24px;\n  }\n}\n\n:global(.internal-root[data-theme=\"light\"]) .topbarTitle img {\n  filter: invert(1);\n}\n\n.topbarRight #shareButton {\n  color: var(--primary);\n  margin-right: 2em;\n}\n\n.topbarRight {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  color: var(--text-muted);\n}\n\n.page {\n  min-height: 100vh;\n  background: var(--bg-base);\n}\n\n.header {\n  padding: 24px 24px 0;\n}\n\n.brand {\n  font-weight: 700;\n  letter-spacing: 0.2px;\n}\n\n.content {\n  padding: 24px;\n  max-width: 1000px;\n  margin: 0 auto;\n}\n\n.h1 {\n  font-size: 20px;\n  margin: 0 0 12px;\n}\n\n.appList {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.appLink {\n  background: var(--bg-surface);\n  border: 1px solid var(--border-color);\n  border-top-color: var(--highlight-color);\n  border-radius: 12px;\n  padding: 20px 14px;\n  color: var(--text-primary);\n  text-decoration: none;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 200%;\n    height: 200%;\n    background: linear-gradient(\n      135deg,\n      transparent 0%,\n      transparent 35%,\n      rgba(255, 255, 255, 0.03) 38%,\n      rgba(255, 255, 255, 0.06) 41%,\n      rgba(255, 255, 255, 0.15) 44%,\n      rgba(255, 255, 255, 0.25) 45.5%,\n      rgba(255, 255, 255, 0.15) 47%,\n      rgba(255, 255, 255, 0.06) 50%,\n      rgba(255, 255, 255, 0.03) 53%,\n      transparent 56%,\n      transparent 100%\n    );\n    transform: translate(-100%, -100%);\n    transition: none;\n    pointer-events: none;\n  }\n\n  &:hover::before {\n    transform: translate(10%, 10%);\n    transition: transform 1.2s ease-in-out;\n  }\n}\n\n:global(.internal-root[data-theme=\"light\"]) .appLink::before {\n  background: linear-gradient(\n    135deg,\n    transparent 0%,\n    transparent 35%,\n    rgba(0, 0, 0, 0.01) 38%,\n    rgba(0, 0, 0, 0.02) 41%,\n    rgba(0, 0, 0, 0.06) 44%,\n    rgba(0, 0, 0, 0.1) 45.5%,\n    rgba(0, 0, 0, 0.06) 47%,\n    rgba(0, 0, 0, 0.02) 50%,\n    rgba(0, 0, 0, 0.01) 53%,\n    transparent 56%,\n    transparent 100%\n  );\n}\n\n.appLink:hover {\n  filter: brightness(1.05);\n}\n\n:global(.internal-root[data-theme=\"light\"]) .appLink:hover {\n  filter: brightness(0.98);\n}\n\n.appName {\n  font-weight: 500;\n}\n\n.stateBadges {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.stateBadge {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  color: var(--text-muted);\n  --badge-icon-filter: brightness(1.25) saturate(1.6) contrast(1.15);\n}\n\n.stateBadge[data-state-key=\"in progress\"] {\n  --badge-icon-filter: brightness(0) saturate(100%) invert(99%) sepia(65%)\n    saturate(5941%) hue-rotate(323deg) brightness(115%) contrast(95%);\n}\n.stateBadge[data-state-key=\"in review\"] {\n  --badge-icon-filter: brightness(0) saturate(100%) invert(51%) sepia(67%)\n    saturate(381%) hue-rotate(70deg) brightness(120%) contrast(95%);\n}\n.stateBadge[data-state-key=\"done\"] {\n  --badge-icon-filter: brightness(0) saturate(100%) invert(44%) sepia(78%)\n    saturate(482%) hue-rotate(197deg) brightness(115%) contrast(95%);\n}\n.stateBadge[data-state-key=\"canceled\"],\n.stateBadge[data-state-key=\"cancelled\"],\n.stateBadge[data-state-key=\"duplicate\"] {\n  --badge-icon-filter: brightness(0) saturate(100%) invert(74%) sepia(7%)\n    saturate(619%) hue-rotate(175deg) brightness(115%) contrast(95%);\n}\n.stateBadge[data-state-key=\"triage\"] {\n  --badge-icon-filter: brightness(0) saturate(100%) invert(56%) sepia(55%)\n    saturate(1002%) hue-rotate(331deg) brightness(120%) contrast(95%);\n}\n.stateBadge[data-state-key=\"todo\"],\n.stateBadge[data-state-key=\"to do\"],\n.stateBadge[data-state-key=\"backlog\"],\n.stateBadge[data-state-key=\"extended features\"] {\n  --badge-icon-filter: brightness(0) saturate(100%) invert(89%) sepia(1%)\n    saturate(209%) hue-rotate(72deg) brightness(125%) contrast(100%);\n}\n\n.stateBadgeIcon {\n  width: 14px;\n  height: 14px;\n  opacity: 0.9;\n  filter: var(--badge-icon-filter, none);\n}\n\n:global(.internal-root[data-theme=\"light\"]) {\n  .stateBadge {\n    --badge-icon-filter: brightness(0.8) saturate(1.4) contrast(1.1);\n  }\n  .stateBadge[data-state-key=\"in progress\"] {\n    --badge-icon-filter: brightness(0) saturate(100%) invert(65%) sepia(65%)\n      saturate(5941%) hue-rotate(323deg) brightness(85%) contrast(95%);\n  }\n  .stateBadge[data-state-key=\"in review\"] {\n    --badge-icon-filter: brightness(0) saturate(100%) invert(42%) sepia(67%)\n      saturate(500%) hue-rotate(70deg) brightness(105%) contrast(90%);\n  }\n  .stateBadge[data-state-key=\"done\"] {\n    --badge-icon-filter: brightness(0) saturate(100%) invert(25%) sepia(80%)\n      saturate(1500%) hue-rotate(197deg) brightness(85%) contrast(100%);\n  }\n  .stateBadge[data-state-key=\"canceled\"],\n  .stateBadge[data-state-key=\"cancelled\"],\n  .stateBadge[data-state-key=\"duplicate\"] {\n    --badge-icon-filter: brightness(0) saturate(100%) invert(40%) sepia(7%)\n      saturate(619%) hue-rotate(175deg) brightness(90%) contrast(95%);\n  }\n  .stateBadge[data-state-key=\"triage\"] {\n    --badge-icon-filter: brightness(0) saturate(100%) invert(25%) sepia(55%)\n      saturate(1002%) hue-rotate(331deg) brightness(90%) contrast(95%);\n  }\n  .stateBadge[data-state-key=\"todo\"],\n  .stateBadge[data-state-key=\"to do\"],\n  .stateBadge[data-state-key=\"backlog\"],\n  .stateBadge[data-state-key=\"extended features\"] {\n    --badge-icon-filter: brightness(0) saturate(100%) invert(30%) sepia(1%)\n      saturate(209%) hue-rotate(72deg) brightness(70%) contrast(100%);\n  }\n}\n\n.themeToggle {\n  background: var(--fill-default);\n  border: 1px solid var(--border-subtle);\n  border-radius: 8px;\n  padding: 6px;\n  cursor: pointer;\n  color: var(--text-muted);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  transition: color 0.15s ease, background 0.15s ease;\n\n  &:hover {\n    color: var(--text-primary);\n    background: var(--fill-hover);\n  }\n}\n\n.button {\n  background: transparent;\n  border: 0;\n  color: var(--text-muted);\n  padding: 0;\n  font-size: 13px;\n  cursor: pointer;\n  text-decoration: none;\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n  font-family: inherit;\n}\n\n.button:hover {\n  color: var(--text-primary);\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.button:focus-visible {\n  outline: 2px solid var(--highlight-color);\n  outline-offset: 2px;\n}\n\n.muted {\n  color: var(--text-muted);\n  font-size: 13px;\n}\n\n.error {\n  color: var(--color-error);\n  font-size: 13px;\n  margin-bottom: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `internalRoot_root__J1tX4`,
	"body": `internalRoot_body__0-N9O`,
	"topbar": `internalRoot_topbar__mo-wm`,
	"topbarLeft": `internalRoot_topbarLeft__Afhaw`,
	"topbarTitle": `internalRoot_topbarTitle__s1vzY`,
	"topbarRight": `internalRoot_topbarRight__j3-NS`,
	"shareButton": `internalRoot_shareButton__SBzBZ`,
	"page": `internalRoot_page__n4xjH`,
	"header": `internalRoot_header__Xa-Eb`,
	"brand": `internalRoot_brand__+DV2Y`,
	"content": `internalRoot_content__LNJPY`,
	"h1": `internalRoot_h1__K1NVo`,
	"appList": `internalRoot_appList__39EKc`,
	"appLink": `internalRoot_appLink__y8NAp`,
	"appName": `internalRoot_appName__iHkwo`,
	"stateBadges": `internalRoot_stateBadges__WXe3l`,
	"stateBadge": `internalRoot_stateBadge__z+q-l`,
	"stateBadgeIcon": `internalRoot_stateBadgeIcon__Scfgh`,
	"themeToggle": `internalRoot_themeToggle__2ksE+`,
	"button": `internalRoot_button__LUebR`,
	"muted": `internalRoot_muted__+goQQ`,
	"error": `internalRoot_error__XneeB`
};
export default ___CSS_LOADER_EXPORT___;
